import BackNavigation from '@components/backNavigation'
import Button from '@components/button'
import Column from '@components/column'
import Fields from '@components/fields'
import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import * as Yup from 'yup'
import { FormWrapper, ProfileContainer, StyleFixedButton } from './style'
import Row from '@components/row'
import { User } from '@apis/index'
import useWindowSize from '@hooks/useWindow'

const validationSchema = Yup.object().shape({
  fullName: Yup.string().required('Full name is required'),
  landmark: Yup.string().required('Landmark is required'),
  address: Yup.string(),
})

const ManageProfile = () => {
  const { data: user } = useSelector((state: any) => state.user)

  const [loading, setLoading] = useState(false)

  const initialValues = {
    fullName: user?.name || '',
    email: user?.email || '',
    phoneNo: user?.phoneNo || '',
    landmark: user?.landmark || '',
    address: user?.address || '',
    avatar: user?.image || null,
    countryCode: user?.countryCode || '',
  }

  const submitHandler = async (values) => {
    setLoading(true)

    const payload: any = {
      name: values?.fullName,
      email: values?.email,
      phoneNo: values?.phoneNo,
      landmark: values?.landmark,
      countryCode: values?.countryCode,
      address: values?.address,
    }
    if (values?.avatar?.base64) {
      payload.image = {
        extension: values?.avatar?.extension,
        base64: values?.avatar?.base64,
      }
    } else {
      payload.image = values?.avatar
    }
    await User.updateProfile(payload)
      .catch(() => {})
      .finally(() => {
        setLoading(false)
      })
  }
  const { width } = useWindowSize()

  const mobile = width < 1024

  return (
    <>
      <BackNavigation title="Edit Profile" />

      <ProfileContainer>
        <FormWrapper>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={submitHandler}
          >
            {({ handleSubmit, setFieldValue }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <Row alignItems="center" justifyContent="center">
                    <Fields.Upload
                      name="avatar"
                      varient="avatar"
                      styleWrapper="align-items:center"
                    />
                  </Row>
                  <Column rowGap={16} styleColumn="margin: 16px 0">
                    <Fields.Input
                      name="fullName"
                      label="Full Name"
                      placeholder="Enter your full name"
                    />
                    <Fields.Input
                      name="email"
                      label="Email"
                      disabled
                      type="email"
                      placeholder="Enter your email"
                    />

                    <Fields.PhoneInput
                      name="phoneNo"
                      label="Mobile Number"
                      disabled
                      onChangeCode={(codes) => {
                        setFieldValue('countryCode', codes.callingCode)
                      }}
                      placeholder="Enter your mobile number"
                    />
                    <Fields.Input
                      name="landmark"
                      label="Landmark"
                      placeholder="Enter nearest landmark"
                    />

                    <Fields.Input
                      name="address"
                      label="Address"
                      placeholder="Enter your address"
                    />
                  </Column>

                  {!mobile ? (
                    <Button
                      title="Save Changes"
                      type="submit"
                      loading={loading}
                      styleButton="width: 100%; height: 40px"
                    />
                  ) : (
                    <StyleFixedButton>
                      <Button
                        title="Save Changes"
                        type="submit"
                        loading={loading}
                        styleButton="width: 100%; height: 40px"
                      />
                    </StyleFixedButton>
                  )}
                </Form>
              )
            }}
          </Formik>
        </FormWrapper>
      </ProfileContainer>
    </>
  )
}

export default ManageProfile
